import Vue from 'vue';
import VueRouter from 'vue-router';

import routes from './routes';
import auth from './auth';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: process.env.VUE_APP_ROUTER_MODE || 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(auth);

export default router;
